
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FabricsPage = lazy(() => import('../pages/fabrics/page'));
const FabricCategoryPage = lazy(() => import('../pages/fabrics/category/page'));
const FabricDetailPage = lazy(() => import('../pages/fabrics/detail/page'));
const TailoringPage = lazy(() => import('../pages/tailoring/page'));
const TailoringStep2Page = lazy(() => import('../pages/tailoring/step2/page'));
const MeasurementsPage = lazy(() => import('../pages/measurements/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/fabrics',
    element: <FabricsPage />,
  },
  {
    path: '/fabrics/:categoryId',
    element: <FabricCategoryPage />,
  },
  {
    path: '/fabrics/detail/:fabricId',
    element: <FabricDetailPage />,
  },
  {
    path: '/tailoring',
    element: <TailoringPage />,
  },
  {
    path: '/tailoring/step2',
    element: <TailoringStep2Page />,
  },
  {
    path: '/measurements',
    element: <MeasurementsPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
